import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { siteRoutes } from "@/routes/siteRoutesList";
import {
  Box,
  Card,
  Text,
  AspectRatio,
  Heading,
  Flex,
  Tooltip,
  Inset,
} from "@radix-ui/themes";
import { Zones } from "@/models/database/zones/Zones.model";
import { CheckCircledIcon } from "@radix-ui/react-icons";

const SingleZoneCard: FC<Zones> = (props): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Box
      minHeight="100%"
      onClick={() => {
        navigate(`${siteRoutes["zone"]}${props.slug}`);
      }}
    >
      <Card size="2" className="card">
        {/* Image */}
        <Inset clip="padding-box" side="top" pb="current">
          <AspectRatio ratio={1 / 1}>
            <img
              src={props.imageURL}
              alt={props.title}
              width="100"
              height="100"
              style={{
                display: "block",
                objectFit: "cover",
                width: "100%",
                height: "100%",
                backgroundColor: "var(--gray-5)",
              }}
            />
          </AspectRatio>
        </Inset>

        <Flex direction="column" gap="5">
          {/* Content */}
          <Flex direction="column" justify="center" gap="5">
            {/* Title and desc */}
            <Flex direction="column" gap="1">
              <Heading as="h3" size="3" align="center">
                <Flex gap="1" align="center">
                  {props.title}
                  <Tooltip content={`${props.title} is a verified zone.`}>
                    <CheckCircledIcon color="lightgreen" />
                  </Tooltip>
                </Flex>
              </Heading>
              <Text as="p" size="2" color="gray">
                {props.desc}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Card>
    </Box>
  );
};
export default SingleZoneCard;
